// Copyright ©️ 2026 eVolve MEP, LLC

import { AutodeskExtensionStoreProvider } from 'components/Autodesk/useAutodeskExtensionStore';
import { ProjectRequired } from 'components/Mantine/GlobalFilters/ProjectRequired';
import { ModelBrowserProvider } from 'modules/Shop/ModelBrowser/ModelBrowserProvider';
import { SpoolAssignmentProvider } from 'modules/Shop/Spooling/hooks/useSpoolAssignment';
import { SpoolRequestsViewerStateProvider } from 'modules/Shop/Spooling/hooks/useSpoolRequestsViewerState';
import { SpoolingBrowser } from 'modules/Shop/Spooling/SpoolingBrowser';

export const SpoolingPage = () => (
  <ProjectRequired title="Spooling">
    <ModelBrowserProvider title="Spooling">
      {(selectedUrn, model) => (
        <AutodeskExtensionStoreProvider storeName="apsViewer">
          <AutodeskExtensionStoreProvider storeName="elementTags">
            <AutodeskExtensionStoreProvider storeName="dimensioning">
              <AutodeskExtensionStoreProvider storeName="spools">
                <SpoolAssignmentProvider model={model}>
                  <SpoolRequestsViewerStateProvider model={model}>
                    <SpoolingBrowser selectedUrn={selectedUrn} model={model} />
                  </SpoolRequestsViewerStateProvider>
                </SpoolAssignmentProvider>
              </AutodeskExtensionStoreProvider>
            </AutodeskExtensionStoreProvider>
          </AutodeskExtensionStoreProvider>
        </AutodeskExtensionStoreProvider>
      )}
    </ModelBrowserProvider>
  </ProjectRequired>
);
